export default "__VITE_ASSET__DeiH0MQ3__"